import ApiClient from '../../utils/api/ApiClient'
import type { SSOClientConfig } from './types'

/**
 * Fetches an SSO client config from the server registry (sso_client table).
 * Returns null when the client is unknown to the server or the request
 * fails, in which case callers fall back to the bundled env-var config.
 */
export const fetchSSOClientConfig = async (clientName: string): Promise<SSOClientConfig | null> => {
  try {
    const { data } = await ApiClient.get(`/sso-clients/${encodeURIComponent(clientName)}`)
    if (typeof data?.clientName !== 'string' || typeof data?.clientId !== 'string') return null
    return data as SSOClientConfig
  } catch {
    return null
  }
}
